import { Link } from 'react-router-dom';
import { AlertCircle, AlertTriangle, CheckCircle2, Info } from 'lucide-react';
import { cn } from '../../utils/cn';
import type { PartnerNotice } from '../../utils/partnerSync';

interface PartnerNoticeBarProps {
  notice: PartnerNotice | null;
  onDismiss: () => void;
  className?: string;
}

const TONE = {
  success: { cls: 'alert-success', Icon: CheckCircle2 },
  info: { cls: 'alert-info', Icon: Info },
  warning: { cls: 'alert-warning', Icon: AlertTriangle },
  danger: { cls: 'alert-danger', Icon: AlertCircle },
} as const;

/** The inline result of the last action, until someone dismisses it. Argus has no toasts. */
export const PartnerNoticeBar = ({ notice, onDismiss, className }: PartnerNoticeBarProps) => {
  if (!notice) return null;
  const { cls, Icon } = TONE[notice.tone];
  return (
    <div className={cn('alert', cls, className)} role={notice.tone === 'danger' ? 'alert' : 'status'}>
      <Icon className="w-4 h-4 shrink-0" />
      <span className="flex-1 min-w-0">
        {notice.text}
        {notice.link && (
          <>
            {' '}
            <Link to={notice.link.to} className="link font-medium">
              {notice.link.label}
            </Link>
          </>
        )}
      </span>
      <button type="button" onClick={onDismiss} className="btn-ghost btn-xs ml-auto shrink-0">
        Dismiss
      </button>
    </div>
  );
};
